import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Internet Explorer 6 — the reason this site exists. Every other place I run
 * on the internet is a Favourite in here, and the ones that permit framing
 * load inside its window rather than taking you away from the desktop.
 *
 * Args:
 *   url       string   address, or a favourite id (`blog`), or an `about:` page
 *   href      string   alias for `url`, as written by `.url` shortcuts
 *   openMode  string   `'newTab'` forces the hand-off page instead of framing
 *   file/path string   path to a `.url` shortcut, resolved through the fs
 *
 * Deliberately not a singleton: File ▸ New ▸ Window has to mean something.
 */
export const ieApp: AppManifest = {
  id: 'ie',
  name: 'Internet Explorer',
  icon: '/assets/icons/ie.svg',
  component: lazy(() => import('./IE')),

  defaultSize: { w: 880, h: 620 },
  minSize: { w: 420, h: 300 },

  singleton: false,
  pinned: true,
  group: 'Internet',
  openWith: ['.url'],

  titleFor: (args) =>
    typeof args.url === 'string' && args.url
      ? `${args.url} - Microsoft Internet Explorer`
      : 'teon.io - Microsoft Internet Explorer',
};
